import RequestsActions from 'client/core/RequestsActions'
import { action } from 'client/core/actions'

/*isAuth: check if user is logged.*/
export const IsAuthRequest = new RequestsActions('IS_AUTH', { excludedMethods: ['post', 'put', 'delete'] })

/*Login form*/
export const LoginRequest = new RequestsActions('LOGIN', { excludedMethods: ['get', 'put', 'delete'] })

/*Magic login */
export const MagicLoginRequest = new RequestsActions('MAGIC_LOGIN', { excludedMethods: ['get', 'put', 'delete'] })

/*Logout*/
export const LogoutRequest = new RequestsActions('LOGOUT', { excludedMethods: ['post', 'put', 'delete'] })

export const SetPasswordRequest = new RequestsActions('SET_PASSWORD')

/*Current user*/
export const CurrentUserRequest = new RequestsActions('CURRENT_USER', { excludedMethods: ['post'] })

export const ResetPasswordRequest = new RequestsActions('RESET_PASSWORD', { excludedMethods: ['get', 'put', 'delete'] })

export const UpdatePasswordRequest = new RequestsActions('UPDATE_PASSWORD', { excludedMethods: ['get', 'put', 'delete'] })

/*Socket connection*/
export const SOCKET_CONNECTION = 'SOCKET_CONNECTION'
export const socketConnection = (client) => action(SOCKET_CONNECTION, client)


// WEBPACK FOOTER //
// ./src/client/features/session/actions.js